var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AbstractAuthenticatedService from '../abstract-authenticated-service';
import DeleteReportTask from '../../task/report/delete-report-task';
import GetReportTask from '../../task/report/get-report-task';
import GetReportsTask from '../../task/report/get-reports-task';
import PinReportTask from '../../task/report/pin-report-task';
import PostReportTask from '../../task/report/post-report-task';
import PutReportTask from '../../task/report/put-report-task';
import UnpinReportTask from '../../task/report/unpin-report-task';
export default class ReportService extends AbstractAuthenticatedService {
    /**
     * Returns matching reports
     *
     * @returns
     */
    findReports(searchConditions) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetReportsTask();
            task.token = this.token;
            task.searchConditions = searchConditions;
            return this.runTask(task);
        });
    }
    /**
     * Loads a report
     *
     * @param id
     * @returns
     */
    loadReport(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetReportTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Creates a report
     *
     * @param report
     * @returns
     */
    createReport(report) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PostReportTask();
            task.token = this.token;
            task.report = report;
            return this.runTask(task);
        });
    }
    /**
     * Updates a report
     *
     * @param report
     * @returns
     */
    updateReport(report) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PutReportTask();
            task.token = this.token;
            task.report = report;
            return this.runTask(task);
        });
    }
    /**
     * Deletes a report
     *
     * @param id
     * @returns
     */
    deleteReport(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new DeleteReportTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Pins a report
     *
     * @param id
     */
    pinReport(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PinReportTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Unpins a report
     *
     * @param id
     */
    unpinReport(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new UnpinReportTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Loads default report columns for a user
     *
     * @param reportId
     * @param projectId
     * @returns
     */
    loadUserDefaultColumns(reportId, projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.store.getters['reports/getDefaultColumnsForReport'](this.userId, reportId, projectId);
        });
    }
    /**
     * Saves default report columns for a user
     *
     * @param reportId
     * @param columns
     * @param projectId
     */
    saveUserDefaultColumns(reportId, columns, projectId = null) {
        return __awaiter(this, void 0, void 0, function* () {
            this.store.commit('reports/defaultColumns', {
                userId: this.userId,
                reportId,
                columns,
                projectId,
            });
        });
    }
}
//# sourceMappingURL=report-service.js.map